import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export function useUpdateQuantityGift() {
  // const liveId = 11;
  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  const updateQuantityGift = useCallback(({ message }: LiveGiftsAnimations) => {
    try {
      const notifyGiftSentQuantityList = Object.assign(
        {},
        useGlobalStore.getState().notifyGiftSentQuantityList,
      )

      const giftName = message?.gift?.name
      const id = `${message?.userSentId}-${message?.userReceivedId}-${giftName}`

      if (notifyGiftSentQuantityList[id]) {
        notifyGiftSentQuantityList[id].quantity += message.quantity
      } else {
        notifyGiftSentQuantityList[id] = message
        notifyGiftSentQuantityList[id].id = id
      }

      useGlobalStore.setState({
        notifyGiftSentQuantityList: notifyGiftSentQuantityList,
      })
    } catch (error) {
      console.error(error)
    }
  }, [])

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: updateQuantityGift,
  })
}
